<template>
  <div
    v-if="items && items.length"
    :class="{
      'gui-container': true,
      'a-sticky-header': true
    }"
  >
    <div class="a-sticky-header__content">
      <Breadcrumbs :items="items" :modifiers="breadcrumbsModifiers" />
    </div>
  </div>
</template>

<script>
import { Breadcrumbs, breakpointsMixin } from "@thegetty-private/getty-ui";

export default {
  name: "StickyHeader",
  components: { Breadcrumbs },
  mixins: [breakpointsMixin],
  props: {
    /**
     * The items to generate the breadcrumbs
     *
     * e.g. [
     *  { url: "#", text: "Test Breadcrumb" },
     *  { url: "#", text: "Next Breadcrumb" }
     * ]
     **/
    items: {
      type: [Array, undefined],
      required: false,
      default: () => []
    }
  },
  emits: ["stickyHeaderHeight"],
  data() {
    return {
      /**
       * Whether the screen size is mobile.
       */
      isMobile: undefined,
      /**
       * Current component DOM element offset height
       */
      offsetHeight: undefined
    };
  },
  computed: {
    /**
     * Checks whether we're displaying in mobile and returns an array with the
     * 'flex' or 'inline' modifiers.
     *
     * @returns {array} - an array with the 'flex' or 'inline' modifier
     */
    breadcrumbsModifiers() {
      if (this.isMobile) {
        return ["flex"];
      }
      return ["inline"];
    }
  },
  watch: {
    /**
     * Watch for new items and setScrollPosition for breadcrumbs in mobile
     */
    items() {
      if (this.isMobile) {
        this.$nextTick(() => {
          this.setScrollPosition();
        });
      }
    },
    offsetHeight() {
      this.$emit("stickyHeaderHeight", this.offsetHeight);
    }
  },
  mounted() {
    // add event listener to reset breadcrumbsModifiers if window size changes
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  updated() {
    this.offsetHeight = this.$el.offsetHeight;
  },
  beforeUnmount() {
    // remove event listener
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    /**
     * Handles resize event, sets isMobile data prop and emits height
     */
    handleResize() {
      this.offsetHeight = this.$el.offsetHeight;
      this.isMobile = this.isSmallMinus();
    },
    /**
     * Scroll to last breadcrumb for mobile.
     */
    setScrollPosition() {
      const el = document.querySelector(".m-breadcrumbs__list--flex");
      el.scrollLeft = el.scrollWidth;
    }
  }
};
</script>

<style lang="scss">
@import "./index";
</style>
